// removed by extract-text-webpack-plugin
module.exports = {"containerIframe":"a8dwGLmt8We5pePM367rQ","FlyerIframe":"_3mqtVdAwD0-eaUgOM_jO8k","containerModalCovid":"_3Irw059QNBk3PYoDrphnF8","textModalCovid":"_1-OPjjMpzy4SxgeKAXjpGx","imgModalCovid":"qMQhK-gdgc4J9hqCI-0Rp","btnEmailModal":"hKjGGCfTy-LnLn2AmA4A2","titleModalCovid":"_2vYc-HRUriFyb4V1ur9YQm"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/Flyers/PreviewFlyers.scss
// module id = 1635
// module chunks = 0